<script>

	import { onMount, onDestroy, tick } from 'svelte';

	import { session } from '../../../lib/stores.js';
	import { autoblur } from '../../../lib/autoblur.js';

	export let tab;
	export let spots;

	let lineLeft = 0;
	let lineWidth = 0;

	$: if (tab) {
		setLine();
	}

	async function setLine() {
		await tick();
		const current = document.getElementById("sessionnav-" + tab);
		if (current) {
			lineLeft = current.offsetLeft + 'px';
			lineWidth = current.offsetWidth + 'px';
		}
	}

	onMount(() => {
		window.addEventListener('resize', setLine);
		screen.orientation.addEventListener("change", setLine);
	});

	onDestroy(() => {
		window.removeEventListener('resize', setLine);
		screen.orientation.removeEventListener("change", setLine);
	});

</script>

<style>
	ul {
		position: relative;
		display: flex;
/*		justify-content: center;*/
		margin: 0.5rem 0.5rem 0 0.5rem;
/*		width: fit-content;*/
		border-radius: 6px;
		width: calc(100% - 1rem);
		box-sizing: border-box;
		padding: 0.1rem 0.3rem;
		z-index: 1000;
		flex: 0 0 auto;
		background: var(--blend-10);
	}

	ul:after {
		content: "";
		position: absolute;
		left: var(--lineLeft, 0);
		bottom: 0.3rem;
		width: var(--lineWidth, 0);
		height: calc(100% - 0.6rem);
		background: var(--bgColor);
		transition: left 0.15s cubic-bezier(0, 0.95, 0.38, 0.98), width 0.2s cubic-bezier(0, 0.95, 0.38, 0.98);
		border-radius: 4px;
	}

	li {
		flex: 1 0 auto;
		display: block;
		margin: 0;
		padding: 0;
		color: var(--textColor);
		text-align: center;
	}

	button {
		position: relative;
		z-index: 2;
		padding: 0.6rem 1rem;
		margin: 0;
		border: 0;
		background: transparent;
		color: var(--textColor);
		text-align: center;
		width: 100%;
		cursor: pointer;
		box-sizing: border-box;
		-webkit-tap-highlight-color: transparent !important;
	}

	li.current button {
		color: var(--accentColor);
	}

	button:focus {
		outline: none;
	}

	button span {
		display: inline-block;
/*		font-size: 0.6875rem;*/
		font-size: 0.9rem;
		font-weight: 600;
		/*transition: transform 0.2s ease;*/
		position: relative;
	}

	button:hover span,
	button:active span,
	button:focus span {
		transform: scale(1.05);
	}

	li.current button:hover span,
	li.current button:active span,
	li.current button:focus span {
		transform: scale(1);
	}
</style>

<ul style="--lineLeft:{lineLeft};--lineWidth:{lineWidth};">
	{#if $session.app.interactions.includes('chat')}
		<li class:current={tab == 'chat'}>
			<button id="sessionnav-chat" type="button" use:autoblur on:click={() => {tab = 'chat'}} class:spot={spots.chat}>
				<span>Chat</span>
			</button>
		</li>
	{/if}
	{#if $session.app.interactions.includes('qa')}
		<li class:current={tab == 'qa'}>
			<button id="sessionnav-qa" type="button" use:autoblur on:click={() => {tab = 'qa'}} class:spot={spots.qa}>
				<span>Q&amp;A</span>
			</button>
		</li>
	{/if}
	{#if $session.app.interactions.includes('polling')}
		<li class:current={tab == 'polling'}>
			<button id="sessionnav-polling" type="button" use:autoblur on:click={() => {tab = 'polling'}} class:spot={spots.polling}>
				<span>Polls</span>
			</button>
		</li>
	{/if}
</ul>